import { render, staticRenderFns } from "./LessonLoadingScreen.vue?vue&type=template&id=47afaccd&scoped=true&"
import script from "./LessonLoadingScreen.vue?vue&type=script&lang=ts&"
export * from "./LessonLoadingScreen.vue?vue&type=script&lang=ts&"
import style0 from "./LessonLoadingScreen.vue?vue&type=style&index=0&id=47afaccd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47afaccd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('47afaccd', component.options)
    } else {
      api.reload('47afaccd', component.options)
    }
    module.hot.accept("./LessonLoadingScreen.vue?vue&type=template&id=47afaccd&scoped=true&", function () {
      api.rerender('47afaccd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/lessons/lesson/LessonLoadingScreen.vue"
export default component.exports